import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationLocationBpConstants {
    static STEP_TITLE = "Location";
    static SAVE_BUTTON_PLACEHOLDER = SharedConstants.SAVE_LABEL;
    static ZONE_LABEL = "Zone";
    static ADD_ZONE_LABEL = "Add zone";
    static OWNER_LABEL = "Owners";
    static REMOVE_PROPERTY_LABEL = "Remove property";
    static COPY_APPLICANT_TO_OWNER_LABEL = "Copy applicant to owner";
    static DESCRIPTION_LABEL_1 = "Search the map to find the property you are lodging an application for by using the 'Find address or place' search bar.";
    static DESCRIPTION_LABEL_2 = "Zoom in close enough to the correct property and click on the property. Click on 'add property' in the window that appears on the map after you selected the property.";
    static DESCRIPTION_LABEL_3 = "The property will be added and the fields must be completed for the property. Note that multiple properties may be added.";
    static DESCRIPTION_LABEL_4 = "The zoning here is the current zoning of the property and an owner should be added for each property (this is linked to the property and the application).";
    static PROPERTY_APPLICATION_DETAILS_LABEL = "Property application details";
    static BUILDING_DETAILS_LABEL = "Building details";
    static MAIN_BUILDING_LABEL = "Main building";
    static OUT_BUILING_LABEL = "Outbuilding / additional building";
    static TOTAL_LABEL = "Total";
    static STOEP_LABEL = "Patios / stoeps";
    static MISCELLANEOUS_LABEL = "Miscellaneous";
    static ERF_NO_CONTROL = "erfNo";
    static SUBDIVISION_CONTROL = "subdivision";
    static FARM_NO_CONTROL = "farmNo";
    static ALLOTMENT_CONTROL = "allotment";
    static SG_CODE_CONTROL = "sgCode";
    static ADDRESS_CONTROL = "address";
    static ERF_SIZE_CONTROL = "erfSize";
    static TITLE_DEED_CONTROL = "titleDeed";
    static ZONE_CONTROL = "zone";
    static OWNER_CONTROL = "owners";
    static PROPERTY_DESCRIPTION_CONTROL = "propertyDescription";
    static TITLE_DEED_RESTRICTION_CONTROL = "titleDeedRestrictions";
    static EXTERNAL_WALLS_CONTROL = "externalWalls";
    static INTERNAL_WALLS_CONTROL = "internalWalls";
    static ROOFING_CONTROL = "roofing";
    static NUMBER_OF_HOUSES_UNITS_CONTROL = "numberOfHousesUnits";
    static TOTAL_EXISTING_CONTROL = "totalExisting";
    static TOTAL_ADDED_CONTROL = "totalAdded";
    static TOTAL_FLOOR_AREA_CONTROL = "totalFloorArea";
    static COVERED_EXISTING_CONTROL = "coveredExisting";
    static COVERED_ADDED_CONTROL = "coveredAdded";
    static OPEN_EXISTING_CONTROL = "openExisting";
    static OPEN_ADDED_CONTROL = "openAdded";
    static TOTAL_EXISTING_PATIO_CONTROL = "totalExistingPatio";
    static TOTAL_ADDED_PATIO_CONTROL = "totalAddedPatio";
    static POOL_CONTROL = "pool";
    static BOUNDARY_WALL_HEIGHT_CONTROL = "boundaryWallHeight";
    static BOUNDARY_WALL_RUNNING_CONTROL = "boundaryWallRunning";
    static COVERAGE_CONTROL = "coverage";
    static BULK_CALCULATION_CONTROL = "bulkCalculation";
    static FLOOR_CONTROL_NAME = "floor";
    static EXISTING_SIZE_CONTROL_NAME = "existingSize";
    static ADDED_SIZE_CONTROL_NAME = "addedSize";
    static BUILDING_NAME_NUMBER_CONTROL_NAME = "buildingNameNumber";
    static ERF_NO_TEXT_PLACEHOLDER = "Erf no";
    static SUBDIVISION_TEXT_PLACEHOLDER = "Subdivision / portion number";
    static FARM_NO_TEXT_PLACEHOLDER = "Farm no";
    static ALLOTMENT_TEXT_PLACEHOLDER = "Allotment / suburb";
    static SG_CODE_TEXT_PLACEHOLDER = "SG Code";
    static ADDRESS_TEXT_PLACEHOLDER = "Address";
    static ERF_SIZE_TEXT_PLACEHOLDER = "Erf size";
    static TITLE_DEED_TEXT_PLACEHOLDER = "Title deed";
    static PROPERTY_DESCRIPTION_LABEL = "Property description";
    static TITLE_DEED_RESTRICTION_LABEL = "Title deed restrictions";
    static EXTERNAL_WALLS_LABEL = "External walls";
    static INTERNAL_WALLS_LABEL = "Internal walls";
    static ROOFING_LABEL = "Roofing";
    static NUMBER_OF_HOUSES_UNITS_LABEL = "Number of houses / units";
    static TOTAL_EXISTING_LABEL = "Total existing (m²)";
    static TOTAL_ADDED_LABEL = "Total added (m²)";
    static TOTAL_FLOOR_AREA_LABEL = "Total floor area (m²)";
    static COVERED_EXISTING_LABEL = "Covered - existing (m²)";
    static COVERED_ADDED_LABEL = "Covered - added (m²)";
    static OPEN_EXISTING_LABEL = "Open - existing (m²)";
    static OPEN_ADDED_LABEL = "Open - added (m²)";
    static TOTAL_EXISTING_PATIO_LABEL = "Total - existing (m²)";
    static TOTAL_ADDED_PATIO_LABEL = "Total - added (m²)";
    static POOL_LABEL = "Pool (m²)";
    static BOUNDARY_WALL_HEIGHT_LABEL = "Boundary wall height (m)";
    static BOUNDARY_WALL_RUNNING_LABEL = "Boundary wall running (m)";
    static COVERAGE_LABEL = "Coverage (%)";
    static BULK_CALCULATION_LABEL = "Bulk calculation (FAR) (%)";
    static CALCULATIONS_LABEL = "Calculations";
    static FLOOR_LABEL = "Floor";
    static EXISTING_SIZE_LABEL = "Existing Size (m²)";
    static ADDED_SIZE_LABEL = "Added Size (m²)";
    static BUILDING_NAME_NUMBER_LABEL = "Building name / number";
    static DUPLICATE_MESSAGE = "The selected property has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static INVALID_OWNER_ATTRIBUTE = "Some owner attribute(s) is missing on the property owner layer. Please contact your systems administrator.";
    static INVALID_ZONING_ATTRIBUTE = "Zoning attribute is missing on the property zoning layer. Please contact your systems administrator.";
    static ZONING_NOT_FOUND = "The found zone ({0}) has not been configured in the lookups. Please contact your systems administrator.";
    static REMOVE_DIALOG_TEXT = `${SharedConstants.REMOVE_TITLE} building`;
    static RESUBMISSION_MESSAGE = "Location cannot be changed for applications marked as resubmission";
    static VALIDATION_MESSAGES = {
        erfNo: {
            required: `Erf no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        subdivision: {
            required: `Subdivision ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        allotment: {
            required: `Allotment ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        farmNo: {
            required: `Farm no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        sgCode: {
            required: `SG code ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        address: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        erfSize: {
            required: `Erf size ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        titleDeed: {
            required: `Title deed ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        zone: {
            required: `Zone ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        propertyDescription: {
            required: `property description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        titleDeedRestrictions: {
            required: `Title deed restrictions ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        externalWalls: {
            required: `External walls ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        internalWalls: {
            required: `Internal walls ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        roofing: {
            required: `Roofing ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        numberOfHousesUnits: {
            required: `Number of houses / units ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        totalExisting: {
            required: `Total existing ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        totalAdded: {
            required: `Total added ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        totalFloorArea: {
            required: `Total floor area ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        coveredExisting: {
            required: `Covered existing ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        coveredAdded: {
            required: `Covered added ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        openExisting: {
            required: `Open existing ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        openAdded: {
            required: `Open added ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        totalExistingPatio: {
            required: `Total existing ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        totalAddedPatio: {
            required: `Total added ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        pool: {
            required: `Pool ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        boundaryWallHeight: {
            required: `Boundary wall height ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        boundaryWallRunning: {
            required: `Boundary wall running ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        coverage: {
            required: `Coverage ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        bulkCalculation: {
            required: `Bulk calculation ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        floor: {
            required: `Floor ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        existingSize: {
            required: `Existing size ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        addedSize: {
            required: `Added size ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
